export default __webpack_public_path__ + "static/media/favicon.89ba5045.ico";